export enum PopupSpeed {
  FAST = 1250,
  MEDIUM = 2250,
  SLOW = 2750,
}
